module.exports = __webpack_public_path__ + "static/media/OutliersQ7_4.0184ca87.svg";